import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { MyProfileService } from '@src/app/modules/my-profile/my-profile.service';
import { CommonService } from '@src/app/services/common.service';
import { NotificationService } from '@src/app/services/notification.service';
import { TelegramService } from '@src/app/services/telegram.service';
import { UserService } from '@src/app/services/user.service';
import { WalletStatusService } from '@src/app/services/wallet-status.service';
import { SharedModule } from '@src/app/shared/shared.module';
import { environment } from '@src/environments/environment';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzModalModule, NzModalService } from 'ng-zorro-antd/modal';
import { filter, Subject, takeUntil } from 'rxjs';
import { MemeSearchComponent } from '../meme-search/meme-search.component';
import { NotificationsComponent } from '../notifications/notifications.component';
import { ProgressCircleComponent } from '../progress-circle/progress-circle.component';
import { ProfileSettingsDropdownComponent } from '@src/app/standalone-components/profile-settings-dropdown/profile-settings-dropdown.component';
import { Router } from '@angular/router';
import { MemeDashboardStatusService } from '@src/app/modules/meme-dashboard/meme-dashboard-status.service';
import { CheckInWeekComponent } from '../check-in-week/check-in-week.component';
import { TgBotEntryCardComponent } from '../tg-bot-entry-card/tg-bot-entry-card.component';

@Component({
    selector: 'app-side-bar',
    standalone: true,
    imports: [
        CommonModule,
        MemeSearchComponent,
        SharedModule,
        NzModalModule,
        ProgressCircleComponent,
        NotificationsComponent,
        NzDropDownModule,
        ProfileSettingsDropdownComponent,
        TgBotEntryCardComponent,
    ],
    templateUrl: './side-bar.component.html',
    styleUrls: ['./side-bar.component.less'],
})
export class SideBarComponent implements OnInit, OnChanges, OnDestroy {
    @Input() sideBarCollapsed = false;
    @Input() sideBarTempExpanded = false;
    @Output() toggleSideBar = new EventEmitter<void>();
    @Output() dropdownVisibleChange = new EventEmitter<boolean>();

    steps = [
        'Connect a wallet',
        'Connect to Hunter Agent',
        'Subscribe a Watchlist',
        'Create and list your watchlist in watchlist marketplace',
        'Refer Friends',
    ];

    getStartedVisible = false;
    notfiVisible = false;
    searchDropDownVisible = false;

    searchVal = '';

    updatingAllowFollowers = false;

    destroy$ = new Subject<void>();

    referCount = 0;

    get notifications() {
        return this.notificationService.messages;
    }

    get completedSteps() {
        return this.steps.filter((_, i) => this.isStepCompleted(i));
    }

    get percentage() {
        return (this.completedSteps.length / this.steps.length) * 100;
    }

    get hasUnreadNotifications() {
        return this.notifications?.some(n => !n.is_read);
    }

    get isSideBarCollapsedNow() {
        return !this.sideBarTempExpanded && this.sideBarCollapsed;
    }

    constructor(
        public commonService: CommonService,
        public walletStatusService: WalletStatusService,
        public userService: UserService,
        private notificationService: NotificationService,
        private profileService: MyProfileService,
        public tgService: TelegramService,
        private router: Router,
        private memeDashboardStatusService: MemeDashboardStatusService,
        private myProfileService: MyProfileService,
        private modalService: NzModalService
    ) {}

    ngOnInit() {
        this.profileService.userProfile$
            .pipe(
                filter(profile => !!profile),
                takeUntil(this.destroy$)
            )
            .subscribe(() => this.myProfileService.getCodeHistory().then(res => (this.referCount = res.total)));
    }

    ngOnChanges() {
        this.notfiVisible = false;
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    dropdownVisible = false;

    onDropdownVisibleChange(visible: boolean) {
        this.dropdownVisible = visible;
        this.dropdownVisibleChange.emit(visible);
    }

    handleToggleSideBar() {
        this.toggleSideBar.emit();
        this.sideBarTempExpanded = false;
    }

    toggleWalletConnection() {
        if (this.walletStatusService.isWalletConnected || this.tgService.isTGLogin) {
            this.userService.logout();
        } else {
            this.commonService.showLogInModal();
        }
    }

    searched() {
        this.searchDropDownVisible = true;
    }

    goToHunterAgent() {
        if (this.walletStatusService.userProfile?.telegram_id || !this.walletStatusService.userProfile) {
            window.open(environment.telegram.botLink, '_blank');
        } else {
            window.open(`${environment.telegram.botLink}?start=bind_${this.walletStatusService.userProfile.id}`, '_blank');
        }
    }

    goToNyXAgent() {
        window.open('https://t.me/nyx_agent_bot', '_blank');
    }

    isStepCompleted(step: number) {
        if (step === 0) {
            return !!this.profileService.userProfile?.wallet_address;
        }

        if (step === 1) {
            return !!this.profileService.userProfile?.telegram_id;
        }

        if (step === 2) {
            return this.memeDashboardStatusService.mySubscribedWatchlistAgents$.getValue();
        }

        if (step === 3) {
            return this.memeDashboardStatusService.myWatchlistAgentInfo$.getValue()?.allow_subscription;
        }

        if (step === 4) {
            return this.referCount > 0;
        }

        return false;
    }

    stepHandler(step: number) {
        if (this.isStepCompleted(step)) return;

        if (step === 0) {
            this.router.navigate(['/my-profile']);
        }

        if (step === 1) {
            this.goToHunterAgent();
        }

        if (step === 2) {
            this.router.navigate(['/meme-dashboard/watchlist-marketplace']);
        }

        if (step === 3) {
            this.router.navigate(['/meme-dashboard/my-watchlist']);
        }

        if (step === 4) {
            this.router.navigate(['/referral']);
        }
    }

    openCheckInModal() {
        this.modalService.create({
            nzContent: CheckInWeekComponent,
            nzCentered: true,
            nzTitle: null,
            nzFooter: null,
            nzWidth: '700px',
            nzStyle: {
                maxWidth: '90vw',
            },
            nzBodyStyle: {
                'overflow-y': 'visible',
            },
        });
    }
}
